import { http } from "../http-common";


const getActiveRoles = () => {
  return http.get(
    `/role-management/getActiveRoles?status=true`
  );
};
const getActiveRolesNew = (profile, countryCode) => {
  let q = `?status=true&isRolePage=true`;
  if (profile == "Global") {
    q += `&attribute=Global`
  }
  if (profile == "Local") {
    q += `&countryCode=${countryCode}`
  }
  return http.get(
    `/role-management/getActiveRoles${q}`
  );
};
const getActiveRolesNewUsers = (profile, countryCode) => {
  let q = `?status=true`;
  if (profile == "Global") {
    q += `&attribute=Global`
  }
  if (profile == "Local") {
    q += `&countryCode=${countryCode}&attribute=Local`
  }
  return http.get(
    `/role-management/getActiveRoles${q}`
  );
};
const getRole = (page, size) => {
  return http.get(`/role-management?pageNumber=${page}&pageSize=${size}`);
};


const getCuringById = ({ id }) => {
  return http.get(
    `culture/{cuCultureId}?cuCultureId=${id}&pageNumber=0&pageSize=10`
  );
};

const updateRole = (data) => {
  return http.put(`/role-management`, data);
};


const createRole = (data) => {
  return http.post(
    `/role-management`, data
  );
};

const deleteManure = ({ id }) => {
  return http.delete(`/greenManure/${id}`)
}




const searchManureData = (keyword) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`);
};


const searchRole = (query,page,size) => {
  return http.get(`/role-management?keyword=${query}&pageNumber=${page}&pageSize=${size}`);
};

const getAllCuringData = (countryCode) => {
  return http.get(`curingunit/allCuringUnits?countryCode=${countryCode}`);
};

const filterManure = (keyword, status) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}&status=${status}`);
};

const filterManureAutocomplete = (keyword) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`);
};

const fetchDelegation = (batOneId) => {
  return http.get(`/delegation/${batOneId}`);
};
const updateDelegation = (data) => {
  return http.put(`/delegation/${data?.delegation}?username=${data?.delegatedByUser}`);
};



const getActiveRolesAdministrator = (profile,countryCode) => {
  let q = `?isAdministrator=true&status=true`;
  if (profile == "Global") {
    q += `&attribute=Global`
  }
  if (profile == "Local") {
    q += `&countryCode=${countryCode}&attribute=Local`
  }

  return http.get(
    `/role-management/getActiveRoles${q}`
  );
};

const isSelfDelegation = (query) => {

  const params = new URLSearchParams();
  params.append("pageNumber", query.pageNumber);
  params.append("pageSize", query.size);
  if (query.status) {
    params.append("status", query.status);
  }


  return http.get(
    `delegation/${query?.batOneId}?isSelfDelegation=true&${params.toString()}`
  );
};

const otherDelegation = (query) => {
  
  const params = new URLSearchParams();
  params.append("pageNumber", query.pageNumber);
  params.append("pageSize", query.size);
  if (query.status) {
    params.append("status", query.status);
  }
  return http.get(
    `delegation/${query?.batOneId}?isSelfDelegation=false&${params.toString()}`
  );
};
const updateAssignmentStatus = (data) => {
  return http.post(`/role-functionality-management/assignment-status?roleId=${data.roleId}&assignmentStatus=${data.assignmentStatus}&serviceNumber=${data.serviceNumber}`);
};
const checkRoleCopyFlag = (roleName) => {
  return http.get(`/role-functionality-management/role-copy-flag?roleName=${roleName}`);
};  
const getCountryFunctionality = (roleName) => {
  return http.get(`/role-functionality-management/country-functionality?roleName=${roleName}`);
};
const autoAssignFunctionalities = (roleId, countryName) => {
  return http.post(`/role-functionality-management/auto-assign-functionalities?roleId=${roleId}&countryName=${countryName}`);
};

// Create/Save Read-Only User Mapping
const saveReadOnlyUserMapping = (data) => {
  // data: { readUserBatOneId: string, realUserBatOneId: string }
  return http.post(`/read-only-user-mapping`, data);
};

const RoleService = {
  getActiveRoles,
  getActiveRolesNew,
  getActiveRolesNewUsers,
  getRole,
  createRole,
  getAllCuringData,
  getCuringById,
  searchManureData,
  updateRole,
  deleteManure,
  searchRole,
  filterManure,
  filterManureAutocomplete,
  fetchDelegation,
  updateDelegation,
  getActiveRolesAdministrator,
  isSelfDelegation,
  otherDelegation,
  updateAssignmentStatus,
  checkRoleCopyFlag,
  getCountryFunctionality,
  autoAssignFunctionalities,
  saveReadOnlyUserMapping, // export
};
export default RoleService;

